import { useContext } from 'react'

import type { ApiClient } from '@/lib/api'

import { ConsoleContext, type ConsoleContextValue } from './consoleContextValue'

export function useConsole(): ConsoleContextValue {
  const value = useContext(ConsoleContext)
  if (value === null) throw new Error('useConsole must be used inside a ConsoleProvider')
  return value
}

export function useApi(): ApiClient {
  return useConsole().api
}
